module.exports = __webpack_public_path__ + "static/img/20160907.c846fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20160907.jpg
// module id = 6CvU
// module chunks = 0